import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mission',
  templateUrl: './mission.component.html',
  styleUrls: ['./mission.component.scss']
})
export class MissionComponent implements OnInit {
  lists = [1, 2, 3, 4, 5, 6,1, 2, 3, 4, 5, 6];

  constructor() { }

  ngOnInit(): void {
  }

}
